 
import React from 'react';

interface IPlusProps {
    width?: number;
    height?: number;
}

const PlusInBanner: React.FC<IPlusProps> = ({width, height}) => {

    return (
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_12843_332366)">
                <path d="M1 5.99609H11" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <path d="M6.00488 1L6.00488 11" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </g>
            <defs>
                <clipPath id="clip0_12843_332366">
                    <rect width="12" height="12" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );

};

export default PlusInBanner;